import { UserType } from "@/types/UserType"

// Response when login is successful (no MFA or MFA completed)
export type SuccessfulLoginResponse = {
  accessToken: string
  accessTokenExpiresIn: string
  refreshToken: string
  refreshTokenExpiresIn: string
  user: UserType
  mfaRequired?: false
}

// Response when MFA is required
export type MFARequiredResponse = {
  mfaRequired: true
  userId: string
  method: 'app' | 'sms' | 'email'
  target: string
}

// Union type for all possible sign-in responses
export type ResponseType = SuccessfulLoginResponse | MFARequiredResponse

// Type guard to check if response requires MFA
export const isMFARequired = (response: ResponseType): response is MFARequiredResponse => {
  return 'mfaRequired' in response && response.mfaRequired === true
}
